// extracted by mini-css-extract-plugin
export default {"error-page":"ErrorBoundary_error-page__UZQj7"};